import { Text } from '@gjensidige/core-typography';
import React from 'react';
import styles from './step-indicator.module.less';
export const StepIndicator = ({ step, maxStep }) => {
    const progressWidth = `${(100 / maxStep) * step}%`;
    return (React.createElement("div", { className: styles.root },
        React.createElement("div", { "aria-label": "steg-indikator", role: "stepIndicator", "aria-valuenow": (100 / maxStep) * step, "aria-valuemin": 0, "aria-valuemax": 100, className: styles.stepIndicator },
            React.createElement(Text, { size: 'small', className: styles.text },
                step,
                " av ",
                maxStep),
            React.createElement("span", { className: styles.progress, style: { width: progressWidth } }))));
};
